import { useCallback, useState } from 'react';
import { useInterval } from 'react-use';
import { InternalMonacoEditorOption } from '../editor/types';
export const useRemeasureFontsHack = _ref => {
  let {
    editorInstance,
    monacoInstance
  } = _ref;
  const [intervalDelay, setIntervalDelay] = useState(100);
  const [startedTime] = useState(Date.now());
  const callback = useCallback(() => {
    var _editorInstance$getDo;
    const element = editorInstance === null || editorInstance === void 0 || (_editorInstance$getDo = editorInstance.getDomNode()) === null || _editorInstance$getDo === void 0 ? void 0 : _editorInstance$getDo.querySelector('.line-numbers');
    if (element == null) {
      return;
    }
    if (element.scrollHeight === (editorInstance === null || editorInstance === void 0 ? void 0 : editorInstance.getOption(InternalMonacoEditorOption.lineHeight)) &&
    // Wait for fonts to load at least 5 seconds
    Date.now() - startedTime > 5 * 1000) {
      setIntervalDelay(null);
      return;
    }
    monacoInstance === null || monacoInstance === void 0 || monacoInstance.editor.remeasureFonts();
  }, [editorInstance, monacoInstance, startedTime]);
  useInterval(callback, intervalDelay);
};